import { Link, useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useState } from "react";

const navigation = [
  { name: "Home", href: "/" },
  { name: "Products", href: "/products" },
  { name: "Services", href: "/services" },
  { name: "About", href: "/about" },
  { name: "FAQ", href: "/faq" },
  { name: "Contact", href: "/contact" },
];

export default function Navbar() {
  const [location] = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-white backdrop-blur-lg border-b border-slate-200/60 shadow-lg">
      <nav className="container flex h-24 items-center justify-between px-4 md:px-6">
        <Link href="/" className="flex items-center group mr-8">
          <div className="relative py-2 overflow-hidden">
            {/* Animated background glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500/0 via-orange-500/20 to-orange-500/0 rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-500 blur-sm"></div>
            
            {/* Logo with multiple animations */}
            <div className="relative transform transition-all duration-500 ease-out group-hover:scale-110 group-hover:rotate-2">
              <img 
                src="/pew-logo-white.png" 
                alt="Panday Engineering Works Logo" 
                className="h-20 w-auto object-contain filter transition-all duration-500 group-hover:brightness-110 group-hover:drop-shadow-lg animate-fadeInScale"
              />
             
              {/* Subtle shine effect on hover */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-700 ease-out"></div>
            </div>
          </div>
            <span className="relative px-4 py-2 text-xl font-semibold text-sky-900 tracking-tight select-none transition-colors duration-300 group-hover:text-orange-400">
              Panday Engineering Works
              </span>
        </Link>

        <div className="hidden md:flex md:gap-x-2">
          {navigation.map((item) => (
            <Link 
              key={item.name} 
              href={item.href}
              className={`relative px-4 py-2 text-sm font-semibold rounded-lg transition-all duration-300 hover:bg-orange-50 hover:text-primary ${
                location === item.href 
                  ? 'text-primary bg-orange-100 shadow-sm' 
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              {item.name}
              {location === item.href && (
                <div className="absolute bottom-0 left-1/2 w-1/2 h-0.5 bg-primary rounded-full transform -translate-x-1/2"></div>
              )}
            </Link>
          ))}
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon">
              <Menu className="h-5 w-5" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="w-[240px] sm:w-[300px]">
            <div className="flex flex-col gap-4 py-4">
              {navigation.map((item) => (
                <Link 
                  key={item.name} 
                  href={item.href}
                  className={`text-sm font-medium transition-colors hover:text-primary ${location === item.href ? 'text-primary' : 'text-muted-foreground'}`}
                  onClick={() => setOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </SheetContent>
        </Sheet>
      </nav>
    </header>
  );
}
